import { FC, useMemo } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import FormRichEditor from '@components/FormRichEditor/FormRichEditor';
import FormSelect from '@components/FormSelect/FormSelect';
import FormTextField from '@components/FormTextField/FormTextField';

import { INewCannedResponseFormProps } from './NewCannedResponseForm.interface';

import './style.scss';

const NewCannedResponseForm: FC<INewCannedResponseFormProps> = ({
  categories,
  formId,
  handleSubmit,
  values,
  isMedication,
}) => {
  const { t } = useTranslation();

  const categoryOptions = useMemo(() => {
    if (isMedication) {
      return categories;
    }
    return [...categories, { id: -1, name: t('adminInquiries.createNewCategory') }];
  }, [categories, t, isMedication]);

  return (
    <form id={formId} className="new-canned-response-form" onSubmit={handleSubmit} noValidate>
      <Typography variant="h3" className="new-canned-response-form__title">
        {t('adminInquiries.addNewCannedComment')}
      </Typography>

      <Field
        component={FormRichEditor}
        className="new-canned-response-form__input"
        label={t('adminInquiries.comments')}
        name="comments"
        required
      />

      <Field
        component={FormSelect}
        className="new-canned-response-form__input"
        label={t('adminInquiries.category')}
        options={categoryOptions}
        name="cannedResponseCategoryId"
        required
      />

      {!isMedication && values.cannedResponseCategoryId === -1 && (
        <Field
          component={FormTextField}
          className="new-canned-response-form__input"
          label={t('adminInquiries.categoryName')}
          name="cannedResponseCategoryName"
          required={values.cannedResponseCategoryId === -1}
        />
      )}
    </form>
  );
};

export default NewCannedResponseForm;
